import React, {useEffect, useState} from 'react';

// custom components
import JobName from '../job-card/job-name';
import JobStatus from '../job-card/job-status';

// styling
import { Spacing } from '_styles';

// utils
import { truncateName } from "_utils/functions";

const CardMiddle = (props) => {

    return (
        <div style={{ 
            padding: Spacing.SCALE_2,
        }}>

            <div style={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}>

                {/* passenger name */}
                <div style={{ flex: 1.5, overflowX: "hidden" }}>
                    <JobName
                        job={props?.job}
                        flightType={props?.flightType}
                    />
                </div>

                {/* gate + stand */}
                <div style={{ display: "flex", flex: 1, alignItems: "center", justifyContent: 'flex-end', overflow: 'hidden' }}>

                    {/* gate and stand with slash separator */}
                    {(props?.gateInformation != '' || props?.standInformation != '') && (
                        <p 
                            style={{ 
                                margin: "0px 0", 
                                fontSize: 10, 
                                fontWeight: "500", 
                                textAlign: "center",
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}
                            data-tippy-content={`${props?.gateInformation != '' ? 'Gate: ' + props?.gateInformation : ''}${props?.gateInformation != '' && props?.standInformation != '' ? ' / ' : ''}${props?.standInformation != '' ? 'Stand: ' + props?.standInformation : ''}`}
                        >
                            {props?.gateInformation != '' && 'G' + props?.gateInformation}
                            {props?.gateInformation != '' && props?.standInformation != '' && ' / '}
                            {props?.standInformation != '' && 'S' + props?.standInformation}
                        </p>
                    )}

                </div>
            </div>

        </div>
    );
};

export default React.memo(CardMiddle, (prev, next) => {
    return (
        prev.job === next.job &&
        prev.flightType === next.flightType &&
        prev.gateInformation === next.gateInformation &&
        prev.standInformation === next.standInformation
    );
});
